/**
 * @brief 글로벌 모달
 * @details
 * @author hyekyoungKang
 * @date 2024-06-14
 * @version 0.0.1
 */

import React, { useContext } from "react";
import styles from "./GlobalModal.module.scss";
import AlertModal from "../AlertModal";
import TermsPrivacyModal from "../TermsPrivacyModal";
import { ModalContext } from "../../../context/Modal/ModalContext";
import TermsInfoCustomerModal from "../TermsInfoCustomerModal";
import TermsServiceModal from "../TermsServiceModal";

const GlobalModal = () => {
    const { isOpen, modalContent, openModal, closeModal } =
        useContext(ModalContext);

    const MODAL_COMPONENTS = {
        AlertModal: AlertModal,
        TermsPrivacyModal: TermsPrivacyModal,
        TermsInfoCustomer: TermsInfoCustomerModal,
        TermsServiceModal: TermsServiceModal,
        // 기타 모달 컴포넌트들...
    };
    const renderComponent = () => {
        if (!isOpen || !modalContent) return null;

        const ComponentToRender = MODAL_COMPONENTS[modalContent.type];

        return (
            <div>
                <div
                    className={`${styles.overlay} ${styles["$bgNone"]}`}
                    onClick={closeModal}
                />
                <div
                    className={`${styles.modalWrapper} ${styles.commonBottom}`}
                    onClick={closeModal}
                >
                    <ComponentToRender {...modalContent.props} />
                </div>
            </div>
        );
    };

    return <>{renderComponent()}</>;
};
export default GlobalModal;
